import { Component, OnInit } from '@angular/core';

import { QuestionnaireService } from '@shared/services/questionnaire.service';

import { LinkRendererComponent } from '@shared/components/cell-renderers/link-renderer/link-renderer.component';
import { Client } from '@app/shared/models/client';

@Component({
  selector: 'db-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  dataGridConfig;
  rowData: any;
  headerTitle: string;
  constructor(
    private questionnaireService: QuestionnaireService
  ) { }

  ngOnInit() {
    this.initializeRowData();
    //this.headerTitle = "Welcome!";
    this.dataGridConfig = {
      columnDefs: [
        {
          headerName: 'Client Id',
          field: 'id',
          minWidth: 200
        },
        {
          headerName: 'Client Name',
          field: 'clientName',
          minWidth: 200
        },
        {
          headerName: 'Can',
          field: 'can',
          minWidth: 200
        },
        {
          headerName: 'Modified Date',
          field: 'date',
          minWidth: 150
        },        
        {
          headerName: '',
          field: 'id',
          cellRenderer: 'linkRenderer',
          cellRendererParams: {
            inRouterLink: '/clients',
            linkTitle: 'View Client'
          },
          minWidth: 150,
          suppressSorting: true,
          suppressFilter: true
        }
      ],
      frameworkComponents: {
        linkRenderer: LinkRendererComponent
      }
    };
  }

  GetSectors() {
    this.questionnaireService.getSectors().subscribe(data => {
      console.log('get sectors' + data);
    });

  }

  initializeRowData() {
    this.questionnaireService.getRecentClients()
      .subscribe((data: Client[]) => {
        this.rowData = data;
      });
  }
}
